import { combineReducers } from "redux";
import userSlice from "../../container/Login/Userslice"

const mainReducer = combineReducers({
    userState: userSlice,
});
const rootReducer = (state, action) => {
    if (action.type === "CLEAR_STORE") {
        // Reset each slice state to its initial state
        state = undefined;
    }
    return mainReducer(state, action);
};

export default rootReducer;